import { analytics } from 'app/utils/segment';
export function getSubmitAnalyticsAction(isAction) {
    return isAction
        ? analytics.flowActionAddSaved
        : analytics.flowActionEditSaved;
}
